var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBluecross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14645 9.35355C8.34171 9.54881 8.65829 9.54881 8.85355 9.35355C9.04881 9.15829 9.04881 8.84171 8.85355 8.64645L5.20711 5L8.85355 1.35355C9.04881 1.15829 9.04881 0.841709 8.85355 0.646447C8.65829 0.451185 8.34171 0.451185 8.14645 0.646447L4.5 4.29289L0.853555 0.646447C0.658292 0.451184 0.34171 0.451184 0.146448 0.646447C-0.0488148 0.841709 -0.0488148 1.15829 0.146448 1.35355L3.79289 5L0.146447 8.64645C-0.0488155 8.84171 -0.0488155 9.15829 0.146447 9.35355C0.341709 9.54881 0.658291 9.54881 0.853553 9.35355L4.5 5.70711L8.14645 9.35355Z",
    fill: "#1B49EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluecross);
export default __webpack_public_path__ + "static/media/bluecross.7a5cc0a6e2238f89b7f82b89dc6de946.svg";
export { ForwardRef as ReactComponent };